import { render } from "./ConsulteGridViews.vue?vue&type=template&id=54a0fcf8&ts=true"
import script from "./ConsulteGridViews.vue?vue&type=script&lang=ts"
export * from "./ConsulteGridViews.vue?vue&type=script&lang=ts"

import "./ConsulteGridViews.vue?vue&type=style&index=0&id=54a0fcf8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__